import "./styles.css";
import { App } from "./app/App.ts";

const rootError = document.getElementById("error-body");
const overlay = document.getElementById("error-overlay");

try {
  const app = new App();
  app.start();
} catch (error) {
  const message = error instanceof Error ? error.message : "GESTUREVERSE failed to start.";
  if (rootError && overlay) {
    rootError.textContent = message;
    overlay.removeAttribute("hidden");
  } else {
    document.body.textContent = message;
  }
}
